import { get, forEach, size } from "lodash";
import { AWS, MS, FR, OCR, LPR, CONTEXT } from "../constants/common";
import { getAttributeValue } from "./profile";
import { getLatestValue } from "./event";

export const getOcrDetails = (eventGroup) => {
  let res = [];
  if (!eventGroup.type || ![10, 11, 12].includes(eventGroup.type.id)) {
    return res;
  }
  if (!eventGroup.events || eventGroup.events.length === 0) {
    return res;
  }
  eventGroup.events.forEach((event) => {
    if (event.active) {
      // Edge OCR result
      if (event.type && event.type.id === 71) {
        if (event.events) {
          event.events.forEach((subEvent) => {
            if (subEvent.active) {
              let rec = {};
              if (subEvent.type && subEvent.type.id === 62) {
                if (subEvent.events && subEvent.events.length > 0) {
                  subEvent.events.forEach((sse) => {
                    if (sse.type && sse.type.id && sse.type.id === 63) {
                      if (sse.attributes) {
                        sse.attributes.forEach((a) => {
                          if (a.id === 91) {
                            rec.match = a.value;
                          }
                        });
                      }
                      if (sse.profile) {
                        rec.profile = sse.profile;
                      }
                    }
                  });
                }
                subEvent.attributes.forEach((attr) => {
                  // Full context image
                  if (attr.id === 2) {
                    rec.contextImage = attr.value;
                  }
                  // Cropped image
                  else if (attr.id === 3) {
                    rec.croppedImage = attr.value;
                  }
                  // Truck Identifier
                  else if (attr.id === 50) {
                    rec.text = attr.value;
                  }
                  // Confidence Index
                  else if (attr.id === 123) {
                    rec.confidenceIndex = attr.value;
                  }
                });
                // subEvent.images.forEach(img => {
                //   if (img.sys_image_type_id === 2) {
                //     if (rec.roiOverlay) {
                //       rec.roiOverlay.push(img.roiOverlay);
                //     } else {
                //       rec.roiOverlay = [img.roi_overlay];
                //     }
                //   }
                // });
              }
              res.push(rec);
            }
          });
        }
      }
    }
  });

  return res;
};

export const getOcrGroupedByPhotos = (eventGroup) => {
  let res = {};
  if (
    !eventGroup ||
    !eventGroup.type ||
    ![10, 11, 12, 23].includes(eventGroup.type.id)
  ) {
    return [];
  }
  if (!eventGroup.events || eventGroup.events.length === 0) {
    return [];
  }

  eventGroup.events.forEach((event) => {
    if (event.active) {
      // Edge OCR result
      if (get(event, ["type", "id"]) === 71) {
        if (event.events) {
          event.events.forEach((subEvent) => {
            if (subEvent.active) {
              let rec = {};
              if (get(subEvent, ["type", "id"]) === 62) {
                if (subEvent.events && subEvent.events.length > 0) {
                  subEvent.events.forEach((sse) => {
                    if (get(sse, ["type", "id"]) === 63) {
                      if (sse.attributes) {
                        sse.attributes.forEach((a) => {
                          if (a.id === 91) {
                            rec.match = a.value;
                          }
                        });
                      }
                      if (sse.profile) {
                        rec.profile = sse.profile;
                      }
                    }
                  });
                }
                subEvent.attributes.forEach((attr) => {
                  // Full context image
                  if (attr.id === 2) {
                    rec.contextImage = attr.value;
                  }
                  // Cropped image
                  else if (attr.id === 3) {
                    rec.croppedImage = attr.value;
                  }
                  // Truck Identifier
                  else if (attr.id === 50) {
                    rec.text = attr.value;
                  }
                  // Confidence Index
                  else if (attr.id === 123) {
                    rec.confidenceIndex = attr.value;
                  }
                });
                subEvent.images.forEach((img) => {
                  if (img.sys_image_type_id === 2 && img.roi_overlay) {
                    rec.roiOverlay = img.roi_overlay;
                  }
                });
              }
              if (!rec.croppedImage) {
                res[Object.keys(res).length + 1] = {
                  contextImage: rec.contextImage,
                  croppedImage: rec.croppedImage,
                  values: [rec.text],
                  profiles: [rec.profile],
                  roiOverlay: rec.roiOverlay,
                };
              } else {
                if (res[rec.croppedImage]) {
                  res[rec.croppedImage].values.push(rec.text);
                  res[rec.croppedImage].profiles.push(rec.profile);
                  //res[rec.croppedImage].roiOverlay.push(rec.roiOverlay);
                } else {
                  res[rec.croppedImage] = {
                    contextImage: rec.contextImage,
                    croppedImage: rec.croppedImage,
                    values: [rec.text],
                    profiles: [rec.profile],
                    roiOverlay: rec.roiOverlay,
                  };
                }
              }
            }
          });
        }
      }
    }
  });
  let ocrs = [];
  Object.keys(res).forEach((k) => {
    ocrs.push(res[k]);
  });

  return ocrs;
};

export const getLprDetails = (eventGroup) => {
  let res = [];
  if (
    !eventGroup ||
    !eventGroup.type ||
    ![10, 11, 12].includes(eventGroup.type.id)
  ) {
    return res;
  }
  if (!eventGroup.events || eventGroup.events.length === 0) {
    return res;
  }
  eventGroup.events.forEach((event) => {
    if (event.active) {
      // Edge LPR result
      if (get(event, ["type", "id"]) === 72) {
        if (event.events) {
          event.events.forEach((subEvent) => {
            if (subEvent.active) {
              let rec = {};
              if (get(subEvent, ["type", "id"]) === 56) {
                if (subEvent.events && subEvent.events.length > 0) {
                  subEvent.events.forEach((sse) => {
                    if (get(sse, ["type", "id"]) === 57) {
                      if (sse.attributes) {
                        sse.attributes.forEach((a) => {
                          if (a.id === 91) {
                            rec.match = a.value;
                          }
                        });
                      }
                      if (sse.profile) {
                        rec.profile = sse.profile;
                      }
                    }
                  });
                }
                subEvent.attributes.forEach((attr) => {
                  // Full context image
                  if (attr.id === 2) {
                    rec.contextImage = attr.value;
                  }
                  // Cropped image
                  else if (attr.id === 3) {
                    rec.croppedImage = attr.value;
                  }
                  // License plate
                  else if (attr.id === 44) {
                    rec.text = attr.value;
                  }
                  // Confidence Index
                  else if (attr.id === 97) {
                    rec.confidenceIndex = attr.value;
                  }
                });
                if (subEvent.images) {
                  subEvent.images.forEach((img) => {
                    if (img.sys_image_type_id === 2) {
                      rec.roiOverlay = img.roi_overlay;
                    }
                  });
                }
              }
              res.push(rec);
            }
          });
        }
      }
    }
  });
  return res;
};

export const getFrDetails = (eventGroup) => {
  if (get(eventGroup, ["type", "id"]) !== 1) {
    return [];
  }
  if (!eventGroup.events || eventGroup.events.length === 0) {
    return [];
  }

  let res = [];
  eventGroup.events.forEach((event) => {
    if (event.active) {
      // Face Detection
      if (get(event, ["type", "id"]) === 2 && event.events) {
        let item = {
          img: event.images,
          lukeIndex: event.luke_index,
        };
        event.events.forEach((subEvent) => {
          if (subEvent.active) {
            // Face (Not) Recognized
            if ([5, 6].includes(subEvent.type.id)) {
              item.faceRecognized = subEvent.type.id === 5 ? true : false;
            }
            // AWS/MS/FR FR Request
            if ([12, 13, 14].includes(subEvent.type.id) && subEvent.events) {
              let service =
                subEvent.type.id === 12
                  ? AWS
                  : subEvent.type.id === 13
                  ? MS
                  : subEvent.type.id === 14
                  ? FR
                  : null;
              item[service] = {
                confidenceIndex: null,
                profileId: null,
              };
              subEvent.events.forEach((sse) => {
                // Rekognition Response
                if ([9, 10, 11].includes(sse.type.id)) {
                  item[service].profileId = get(sse, ["profile", "id"]);
                  item[service].confidenceIndex = getAttributeValue(
                    sse,
                    service === AWS ? 71 : service === MS ? 72 : 73
                  );
                }
              });
            }
          }
        });
        res.push(item);
      }
    }
  });

  return res;
};

/** Get context photos from the detection
 * example: detections = [ocr, lpr, fr] */
export const getContextPhotos = (detections) => {
  let result = new Set();
  if (detections) {
    detections.forEach((detection) => {
      if (detection) {
        detection.forEach((value) => {
          if (value.contextImage) {
            result.add(value.contextImage);
          }
        });
      }
    });
  }
  return Array.from(result);
};

/** Get context photos from the detection
 * example: detections = [ocr, lpr, fr] */
export const getContextPhotosWithRoi = (detections) => {
  let contextPhotos = {};
  if (detections) {
    detections.forEach((detection) => {
      if (detection) {
        detection.forEach((value) => {
          if (value.contextImage) {
            if (contextPhotos[value.contextImage]) {
              contextPhotos[value.contextImage].push(value.roiOverlay);
            } else {
              contextPhotos[value.contextImage] = [value.roiOverlay];
            }
          }
        });
      }
    });
  }
  let result = [];
  Object.keys(contextPhotos).forEach((k) => {
    result.push({
      contextImage: k,
      roiOverlay: contextPhotos[k],
    });
  });
  return result;
};

/** Get cropped photos from the detection
 * example: detections = [ocr, lpr] */
export const getCroppedPhotos = (detections) => {
  let result = new Set();
  if (detections) {
    detections.forEach((detection) => {
      if (detection) {
        detection.forEach((value) => {
          if (value.croppedImage) {
            result.add(value.croppedImage);
          }
        });
      }
    });
  }
  return Array.from(result);
};

/**
 * ex: eventsHierarchy = [71,62,76]
 * return events 76 of event 62 of event 71
 */
export const getSubEvent = (eventsHierarchy, parentEvent = {}) => {
  let event = parentEvent;
  eventsHierarchy.forEach((id, index) => {
    if (event && event.events) {
      event = event.events.filter((e) => e.type && e.type.id === id);
      if (event.length > 0) {
        if (index < eventsHierarchy.length - 1) {
          event = event[0];
        }
      } else {
        event = [];
      }
    } else {
      event = [];
    }
  });
  return event;
};

export const getOcrLprLatestValue = (photos) => {
  let values = [];

  forEach(photos, (p) => {
    if (p.type !== CONTEXT) {
      if (size(get(p, ["events"])) === 0) {
        values.push({
          id: p.type === OCR ? 50 : 44,
          value: get(p, ["values", 0]) || "",
        });
      } else {
        let value;
        let mostRecentEvent = p.events.sort(
          (a, b) => new Date(b.created_on) - new Date(a.created_on)
        )[0];
        if ([76, 78].includes(mostRecentEvent.type.id)) {
          value = get(p, ["values", 0]) || "";
        } else {
          value = getAttributeValue(
            mostRecentEvent,
            p.type === "OCR" ? 50 : 44
          );
        }
        values.push({ id: p.type === "OCR" ? 50 : 44, value });
      }
    }
  });
  return values;
};

// Return the latest values of all LPR/OCR from photos
export const getOcrLprFromPhotos = (photos) => {
  let allValues = {
    ocr: new Set(),
    lpr: new Set(),
  };
  photos.forEach((p) => {
    if (getLatestValue(p)[0]) {
      if (p.type === OCR) {
        allValues.ocr.add(getLatestValue(p)[0]);
      } else if (p.type === LPR) {
        allValues.lpr.add(getLatestValue(p)[0]);
      }
    }
  });
  allValues.ocr = Array.from(allValues.ocr);
  allValues.lpr = Array.from(allValues.lpr);
  return allValues;
};
